export default "__VITE_ASSET__36121313__"